import { Button, Dialog, DialogActions, DialogTitle, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { ContactsDialog } from "../../../page/PersonRepositoryPage/ContactsDialog";
import { CreateTaskDialog } from "../../../page/TaskPage/CreateTaskDialog";

export default function SelectCreateTaskOrContactDialog(props) {
    const { t } = useTranslation();

    const { openDialog: openCreateTaskDialog } = useDialogBetter();

    const { openDialog: openCreateContactDialog } = useDialogBetter();


    return (
        <Dialog fullWidth open={props.open} maxWidth={"xs"}>
            <DialogTitle align={"center"} color={"primary"} className="capitalize-first-letter">
                {t("clients.discovery.selectCreateTaskOrContactDialog")}
            </DialogTitle>
            <DialogActions sx={{ justifyContent: "center", marginBlock: 2 }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                >
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            color={"success"}
                            style={{ minWidth: "100px" }}
                            variant="contained"
                            size="medium"
                            onClick={() =>
                                openCreateTaskDialog({
                                    Component: CreateTaskDialog,
                                    componentProps: {
                                        customerId: props.customerId,
                                        defaultSellerId: props.sellerId,
                                        onSubmitCallback: props.onClose,
                                    },
                                })
                            }
                        >
                            {t("clients.discovery.createTask")}
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"left"}>
                        <Button
                            color={"primary"}
                            style={{ minWidth: "100px" }}
                            variant="contained"
                            size="medium"
                            onClick={() =>
                                openCreateContactDialog({
                                    Component: ContactsDialog,
                                    componentProps: {
                                        personId: props.personId,
                                        onSubmitCallback: props.onClose,
                                        defaultSellerId: props.sellerId,
                                    },
                                })
                            }
                        >
                            {t("clients.discovery.createContact")}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

SelectCreateTaskOrContactDialog.propTypes = {
    open: PropTypes.bool,
    sellerId: PropTypes.string,
    customerId: PropTypes.string,
    personId: PropTypes.string,
};

SelectCreateTaskOrContactDialog.defaultProps = {
    open: false,
};
